import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

/**
 * @Author: 韩祺涛
 * @Date: 2022-11-28
 * @Project: 杭氧
 */
// // 获取使用部门树
// export function getDeptTreeList (parameter) {
//   return axios({
//     // url: sysInfo.apiRemote + '/company/companyTree',
//     url: '/data/assetDept.json',
//     method: 'GET',
//     params: parameter
//   })
// }
// // 获取使用部门树,搜索条件中使用
// export function getDeptTreeListInSearch (parameter) {
//   return axios({
//     // url: sysInfo.apiRemote + '/company/tree',
//     url: '/data/assetDept.json',
//     method: 'GET',
//     params: parameter
//   })
// }
// // 获取资产分类树
// export function getAssetTypeTreeList (parameter) {
//   return axios({
//     url: sysInfo.apiRemote + '/dict/query',
//     // url: sysInfo.apiRemote + '/asset/getZCFL', // 最新接口，现场用
//     method: 'GET',
//     params: parameter
//   })
// }
// // 获取资产状态
// export function assetTypeList (parameter) {
//   return axios({
//     // url: sysInfo.apiRemote + '/asset/getZCZT',
//     url: '/data/getZCZT.json',
//     method: 'GET',
//     params: parameter
//   })
// }
// 获取增加方式，使用状态，归口部门下拉数据
export function getSelectDataList (parameter) {
  return axios({
    // url: sysInfo.apiRemote + '/asset/getZCDICT',
    url: '/data/getZCDICT.json',
    method: 'GET',
    params: parameter
  })
}
// 获取资产表格
export function getAssetTableData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/list',
    // url: '/data/assetList.json',
    method: 'GET',
    params: parameter
  })
}
// 资产统计
export function getAssetTableTotal (parameter) {
  return axios({
    // url: '/data/assetStatistics.json',
    url: sysInfo.apiRemote + '/asset/statistics',
    method: 'GET',
    params: parameter
  })
}

// 备件管理-库存信息
export function getInventoryInformation (parameter) {
  return axios({
    url: '/data/inventoryInformation.json',
    // url: sysInfo.apiRemote + '',
    method: 'GET',
    params: parameter
  })
}
// 备件管理-关联设备
export function getAssociatedDeviceData (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/asset/list',
    method: 'GET',
    params: parameter
  })
}
